import React from 'react';
import type { OrganizerWithFollowStatus } from '@/components/OrganizerCard/types';
import { OrganizerStats } from './OrganizerStats';
import styles from './OrganizerData.module.scss';
import { OrganizerAvatar } from './OrganizerAvatar/OrganizerAvatar';
import { useAppContext } from '@/components/_shared/context/AppContext';

interface OrganizerDataProps {
  organizer: OrganizerWithFollowStatus;
}

export const OrganizerData: React.FC<OrganizerDataProps> = ({ organizer }) => {
  const { data: appContextData } = useAppContext();
  const domainUrl = appContextData.serverUrl;

  return (
    <div className={styles.wrapper} data-testid="organizer-data">
      <div className={styles.avatarContainer}>
        <OrganizerAvatar organizer={organizer} />
      </div>
      <div className={styles.contentContainer}>
        <a
          href={`${domainUrl}/o/${organizer.id}`}
          className={styles.organizerName}
          target="_blank"
          rel="noopener noreferrer"
        >
          {organizer.name}
        </a>
        <OrganizerStats organizer={organizer} />
      </div>
    </div>
  );
};
